import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'api';
import useCallbackAsync from 'hooks/useCallbackAsync';
import { GeneralSuggestedAction } from 'models/SuggestedActions';
import { removeGeneralSuggestedAction } from '../utils';
import { GeneralSuggestedActionUndoHandlers } from './useGeneralUndoActions';

const useGeneralThreeDotsOptions = (
  suggestion: GeneralSuggestedAction,
  {
    setMutedActionType,
    setMuteUndoTimeout,
  }: GeneralSuggestedActionUndoHandlers,
) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const { type } = suggestion;

  const [onDontRemindMe, isDontReminding] = useCallbackAsync(async () => {
    await api.userSuggestedActions.muteGeneralSuggestedAction(type);

    removeGeneralSuggestedAction(queryClient, type);
    setMutedActionType(type);
    setMuteUndoTimeout();
  });

  const threeDotsOptions = useMemo(
    () => [
      {
        label: t('dontRemindMeAgain'),
        disabled: isDontReminding,
        onClick: onDontRemindMe,
      },
    ],
    [isDontReminding, onDontRemindMe, t],
  );

  return {
    isDontReminding,
    threeDotsOptions,
  };
};

export default useGeneralThreeDotsOptions;
